import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-services9',
  templateUrl: './section-services9.component.html',
  styleUrls: ['./section-services9.component.css']
})
export class SectionServices9Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
